import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/tailwindcss.css'
import './assets/css/iconfont.css'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'

createApp(App).use(store).use(router).use(ElementPlus, {
  locale: zhCn
}).directive('focus', {
  // 当绑定元素插入到 DOM 中。
  mounted: function (el) {
    // 聚焦元素
    el.focus()
  }
}).mount('#app')
